import React, { Component } from 'react';
import authService from './api-authorization/AuthorizeService'

export class CompanyOffer extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.populateState());
    this.populateState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  async populateState() {
    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
    this.setState(prevState => ({
      ...prevState,
      isAuthenticated,
      userName: user && user.name
    }));
  }

  render () {
    return (
      <div class="main">
<p style={{textAlign: "center"}}>
ПУБЛИЧНАЯ ОФЕРТА<br/>
о заключении договора на использование платформы «Planna»</p>

<p style={{display: "none"}}>
  г. [Ваш город]
«» ___________ 20г.
  , в лице [Должность, ФИО], действующего на основании [Устава]</p>

<p>ООО "Планна", именуемое в дальнейшем «Администрация», предлагает любому юридическому лицу или индивидуальному предпринимателю (далее — «Пользователь») заключить настоящий Договор присоединения на изложенных ниже условиях (далее — «Договор» или «Оферта»).</p>

<ol><li>ТЕРМИНЫ
<ol>
<li>Акцепт — полное и безоговорочное принятие Пользователем условий настоящей Оферты путём совершения конклюдентных действий: регистрации и активации учётной записи Поставщика Услуг на Платформе.</li>
<li>Платформа Planna — программно-аппаратный комплекс, доступный по адресу [planna.app] и через мобильные приложения.</li>
<li>Поставщик Услуг (Партнёр) — Пользователь, успешно прошедший регистрацию и акцептовавший Оферту, размещающий информацию об услугах для бронирования и/или аренды клиентами через Платформу.</li>
<li>Услуги — любые предложения Поставщика, доступные для бронирования/аренды через Платформу, включая, но не ограничиваясь: столики в заведениях питания, номера в отелях и апартаментах, записи на приёмы (парикмахерские, спа, медицинские и иные услуги), аренду движимого и недвижимого имущества (транспорт, инструменты, оборудование, одежда, жильё и т.д.).</li>
<li>Дополнительные сервисы Администрации — необязательные к использованию технологические услуги, оказываемые Администрацией Поставщику для расширения функционала Платформы, включая, но не ограничиваясь: приём онлайн-платежей (эквайринг) и отправку SMS-уведомлений клиентам.</li>
</ol>
</li></ol>
<p>2. ПРЕДМЕТ ДОГОВОРА. БЕСПЛАТНЫЙ БАЗОВЫЙ ФУНКЦИОНАЛ</p>

<p>2.1. Гарантия бесплатного использования.</p>
<p>Администрация гарантирует,что предоставление Поставщику права использования базового функционала Платформы, указанного в п. 2.2, является абсолютно бесплатным, неограниченным по сроку («навсегда») и не зависит от:</p>
<p>
· Объёма бронирований или количества транзакций, совершённых через Платформу.
· Размера, оборота или иных финансовых показателей компании Поставщика.
· Количества сотрудников, точек оказания услуг или размещённых предложений.
</p>
<p>2.2. Бесплатный базовый функционал.</p>
<p>На условиях,указанных в п. 2.1, Администрация предоставляет Поставщику право использовать полный базовый функционал Платформы для:</p>
<p>
· Создания и ведения профиля компании.
· Размещения любых Услуг (включая услуги бронирования и предложения по аренде) с описанием, графиком работы, ценами и условиями.
· Приёма, подтверждения, изменения и отмены онлайн-бронирований и заявок от клиентов.
· Использования интеллектуального календаря и инструментов управления расписанием, включая уникальную функцию синхронизации рабочего и личного календарей сотрудников для предотвращения конфликтов.
· Просмотра аналитики по бронированиям и загрузке.
· Использования функции «Поиск партнёра» для формирования совместных бронирований клиентов.
</p>
<p>2.3. Отсутствие платы за базовый функционал.</p>
<p>
За доступ и использование функционала, указанного в п. 2.2, Администрация не взимает с Поставщика и не будет взимать в будущем абонентскую плату, плату за подключение, комиссию (%) с суммы бронирования или иные регулярные платежи.
</p>
<p>3. ДОПОЛНИТЕЛЬНЫЕ СЕРВИСЫ (ЭКВАЙРИНГ И SMS). КОМИССИЯ</p>
<p>
3.1. Поставщик вправе, но не обязан подключать и использовать Дополнительные сервисы Администрации.
3.2. Эквайринг. В случае подключения сервиса приёма онлайн-платежей:
    *   Администрация обеспечивает техническую интеграцию с платёжными шлюзами.
    *   Администрация удерживает с каждой успешной транзакциикомиссию за эквайринг, которая покрывает фактические затраты Администрации на проведение платежа (тарифы банков/платёжных систем) и включает технологическую надбавку (маржа) Администрации.
3.3. SMS-уведомления. В случае подключения сервиса SMS-информирования:
    *   Администрация обеспечивает отправку служебных сообщений клиентам(подтверждение, напоминание).
    *   Администрация удерживаеткомиссию за отправку SMS, которая покрывает фактические затраты Администрации на услуги сервисов рассылок и включает технологическую надбавку (маржа) Администрации.
3.4. Размер комиссий за каждый из Дополнительных сервисов, порядок их расчёта и удержания публикуются в Личном кабинете Поставщика в разделе «Тарифы» и являются неотъемлемой частью настоящей Оферты.
3.5. Администрация оставляет за собой право изменять размер комиссий с предварительным уведомлением Поставщика за 15 (пятнадцать) календарных дней путём публикации новых тарифов в Личном кабинете.
</p>
<p>4. РАСЧЁТЫ И ВЫПЛАТА ДЕНЕЖНЫХ СРЕДСТВ ПОСТАВЩИКУ</p>
<p>
4.1. Денежные средства, полученные от клиентов через сервис эквайринга Администрации за Услуги Поставщика, за вычетом применимых комиссий (п. 3), аккумулируются Администрацией.
4.2. Выплата накопленных средств Поставщику производится по запросу Поставщика из Личного кабинета, при условии наличия минимальной выплачиваемой суммы, установленной в Личном кабинете.
4.3. Администрация вправе удержать дополнительную комиссию за перевод денежных средств Поставщику, если затраты на проведение такого перевода (комиссия банка, платёжной системы) не включены в иные комиссии по разделу 3. Размер и условия применения данной комиссии доводятся до Поставщика до момента инициации выплаты.
</p>
<p>5. ПРЕМИУМ-УСЛУГИ</p>
<p>
5.1. Администрация оставляет за собой право в будущем вводить иные премиум-услуги (например, продвижение услуг (рекламу) в интерфейсе Платформы, расширенную аналитику, кастомизированные интеграции). Подключение к таким сервисам будет исключительно добровольным и регулироваться отдельными офертами.
5.2. Гарантия сохранения бесплатного базового доступа.
Неподключение Поставщика к любым Дополнительным (Раздел 3) или Премиум-услугам (п. 5.1) никоим образом не ограничивает, не ухудшает и не отменяет его права на бесплатное, полное и бессрочное использование базового функционала Платформы, как это гарантировано в Разделе 2.
</p>
<p>6. ОБЯЗАННОСТИ ПОСТАВЩИКА</p>
<p>
6.1. При размещении Услуг на Платформе Поставщик обязуется предоставлять достоверную, полную и актуальную информацию.<br/>
6.2. Поставщик обязуется своевременно обрабатывать входящие бронирования (подтверждать, отклонять).<br/>
6.3. Поставщик обязуется добросовестно исполнять обязательства, принятые перед клиентами через Платформу.<br/>
6.4. Поставщик несёт полную ответственность за соответствие размещённых Услуг требованиям действующего законодательства.<br/>
</p>
<p>7. РЕГИСТРАЦИЯ, АКЦЕПТ И ДАННЫЕ СТОРОН</p>
<p>
7.1. Реквизиты и подпись Администрации (Оферента):
    *   Наименование:[Ваше полное юридическое название]
    *   ИНН/КПП:[Ваши ИНН, КПП]
    *   Юридический адрес:[Ваш юридический адрес]
    *   Подпись уполномоченного лица:Настоящая публичная оферта является юридически значимым электронным документом, подписанным простой электронной подписью в виде факта её публикации на официальном сайте Администрации по адресу: [planna.ru/companyoffer].
7.2. Данные и акцепт Поставщика (Пользователя):
    *   Акцептом Оферты считается последовательное выполнение Пользователем при регистрации всех требуемых действий: заполнение полей с данными и проставление отметки (галочки) в специальном поле «Я согласен с условиями Договора-оферты».
    *   Подписью Пользователяна данном Договоре признаются совершённые им действия по акцепту, а также логин и пароль учётной записи, используемые в дальнейшем для входа в Платформу.
    *   Реквизиты Пользователядля целей данного Договора — это данные, указанные им при регистрации (наименование организации, ИНН, адрес, контактный email и телефон). Пользователь гарантирует их достоверность.
</p>
<p>8. МАРКЕТИНГ И ПРОДВИЖЕНИЕ</p>
<p>
8.1. Информационный стенд. В целях продвижения Платформы и информирования клиентов, Поставщик обязуется в течение 30 (тридцати) календарных дней с момента активации аккаунта разместить в месте оказания Услуг (на ресепшене, в видимой зоне зала, в кабинете и т.д.) информационный стенд (стикер, табличку, постер).
8.2. Содержание стенда.Стенд должен содержать информацию о том, что бронирование Услуг Поставщика осуществляется через систему «Planna», а также QR-код, ведущий на персональную страницу Поставщика в Платформе. Данная страница содержит информацию только об Услугах данного Поставщика и предоставляет клиенту возможность моментального онлайн-бронирования.
8.3. Материалы.Администрация предоставляет Поставщику в Личном кабинете:
    *   Ссылку для скачиванияготового макета стенда, адаптированного под стандарты Платформы.
    *   Персональную ссылкуи QR-код, ведущие на страницу Поставщика.
    *   Инструменты для кастомизациимакета (возможность добавить собственный баннер, логотип, выбрать цветовую схему) с последующей генерацией файла для печати.
8.4. Неисполнение обязанности по размещению информационного стенда не является основанием для прекращения или ограничения доступа к Платформе, но может учитываться Администрацией при рассмотрении заявок на участие в рекламных и партнёрских программах.
</p>
<p>9. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ</p>

<p>
9.1. Настоящая Оферта вступает в силу с момента её публикации и действует до отзыва. Договор считается заключённым с момента Акцепта.
9.2. Администрация вправе изменять условия настоящей Оферты, за исключением гарантий, данных в Разделе 2 (Бесплатный базовый функционал). Изменения иных условий вступают в силу через 30 (тридцать) календарных дней после публикации новой редакции на сайте, если иной срок не указан особо.
9.3. При несогласии с изменениями Поставщик вправе расторгнуть Договор, деактивировав аккаунт в течение срока действия старых условий. Продолжение использования Платформы после вступления изменений в силу считается их принятием.
</p>
---
<p>
Факт публикации и действия Администрации,
совершённые в соответствии с п. 7.1,
признаются её юридически значимой подписью под настоящей Офертой.
</p>
      </div>
    );
  }
}
